import ExitToApp from '@material-ui/icons/ExitToApp';
import PermIdentity from '@material-ui/icons/PermIdentity';
import Lock from '@material-ui/icons/Lock';
import store from '../../store';
import { PHARMACY_ROUTES } from './routes';
import { logout } from '../../reducers/authenticationReducer';
import { redirect } from '../../helpers/redirect';

const toolbarMenuItems = [
  {
    translationKey: 'pharmacytDashboard.profile',
    label: '',
    icon: PermIdentity,
    action: () => redirect(PHARMACY_ROUTES.profile),
  },
  {
    translationKey: 'pharmacytDashboard.changePassword',
    label: '',
    icon: Lock,
    action: () => redirect(PHARMACY_ROUTES.changePassword),
  },
  {
    translationKey: 'pharmacytDashboard.logout',
    label: '',
    icon: ExitToApp,
    action: () => store.dispatch(logout())
  }
];

export default toolbarMenuItems;
